module.exports = __webpack_public_path__ + "assets/img/ability12.80eebd42.png";